<div class="m-8">
  <mat-tab-group>
    <mat-tab label="Conservation">
      <div class="pdf-container">
        <div class="pdf-viewer-wrapper">
          <iframe 
            [src]="biodiversityPdfUrl" 
            class="pdf-viewer">
          </iframe>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Policy">
      <div class="pdf-container">
        <div class="pdf-viewer-wrapper">
          <iframe 
            [src]="policyPdfUrl" 
            class="pdf-viewer">
          </iframe>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>